import { render, staticRenderFns } from "./ResourceInformation.vue?vue&type=template&id=4c7bbb03"
import script from "./ResourceInformation.ts?vue&type=script&lang=ts&external"
export * from "./ResourceInformation.ts?vue&type=script&lang=ts&external"
import style0 from "./ResourceInformation.vue?vue&type=style&index=0&id=4c7bbb03&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports